export const BENCHMARK_AUTH_READY = "model-benchmark.auth.ready";
export const BENCHMARK_AUTH_TOKEN = "model-benchmark.auth.token";

const TRUSTED_PROTOCOLS = new Set(["http:", "https:"]);

export function getTrustedTalentHubOrigin(value: string): string | null {
  try {
    const url = new URL(value);
    return TRUSTED_PROTOCOLS.has(url.protocol) ? url.origin : null;
  } catch {
    return null;
  }
}

export function getTrustedBenchmarkToken(
  event: MessageEvent<unknown>,
  parentWindow: Window,
  talentHubOrigin: string,
): string | null {
  const data = event.data;
  if (
    event.origin !== talentHubOrigin ||
    event.source !== parentWindow ||
    typeof data !== "object" ||
    data === null ||
    !("type" in data) ||
    data.type !== BENCHMARK_AUTH_TOKEN ||
    !("token" in data) ||
    typeof data.token !== "string" ||
    !data.token.trim()
  ) {
    return null;
  }

  return data.token;
}
